module.exports = __webpack_public_path__ + "static/media/orders.0dcbb006.svg";